import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${process.env.REACT_APP_API_BASE_URL}/vehicle-groups`;

async function create(payload) {
	try {
		let response = await api.post(`${basePath}`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.create"
		);
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.create");
		return null;
	}
}

async function update(payload) {
	try {
		let response = await api.put(`${basePath}/${payload.id ?? payload.vehicleGroupId}`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.update"
		);
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.update");
		return null;
	}
}

async function defineDefault(id) {
	try {
		let response = await api.patch(`${basePath}/${id}/default`);
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.defineDefault"
		);
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.defineDefault");
		return null;
	}
}

async function remove(id) {
	try {
		let response = await api.delete(`${basePath}/${id}`);

		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.remove"
		);

		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.remove");
		return null;
	}
}

async function fetchGroups() {
	try {
		var url = `https://nc8.olharfixo.com.br/Vehicles/api/v3/vehicle-groups`;
		let response = await api.get(url);

		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.fetchGroups"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.fetchGroups");
		return null;
	}
}

async function getGroupById(id) {
	try {
		let response = await api.get(`https://nc8.olharfixo.com.br/Vehicles/api/v3/vehicle-groups/${id}`);
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.getGroupById"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.getGroupById");
		return null;
	}
}

async function sendMovement(id, payload) {
	try {
		let response = await api.patch(`https://nc8.olharfixo.com.br/Vehicles/api/v3/groups/${id}/config/movement`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendMovement"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendMovement");
		return null;
	}
}

async function sendSpeed(id, payload) {
	try {
		let response = await api.patch(`https://nc8.olharfixo.com.br/Vehicles/api/v3/groups/${id}/config/speed`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendSpeed"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendSpeed");
		return null;
	}
}

async function insertEmail(id, payload) {
	try {
		let response = await api.post(`https://nc8.olharfixo.com.br/Vehicles/api/v3/groups/${id}/config/emails`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.insertEmail"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.insertEmail");
		return null;
	}
}

async function listEmail(groupId, vehicleGroupTypeEmailId) {
	try {
		let response = await api.get(`https://nc8.olharfixo.com.br/Vehicles/api/v3/groups/${groupId}/config/emails?vehicleGroupTypeEmailId=${vehicleGroupTypeEmailId}`);
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.listEmail"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.listEmail");
		return null;
	}
}

async function deleteEmail(groupId, vehicleGroupEmailId) {
	try {
		let response = await api.delete(`https://nc8.olharfixo.com.br/Vehicles/api/v3/groups/${groupId}/config/emails?emailId=${vehicleGroupEmailId}`);
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.deleteEmail"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.deleteEmail");
		return null;
	}
}

async function sendGroups(payload) {
	try {
		let response = await api.patch(`${basePath}/vehicles/group`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendGroups"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendGroups");
		return null;
	}
}

async function bindUsersGroups(payload) {
	try {
		var url = `${basePath}/user-vehicle-groups`

		let response = await api.patch(url, JSON.stringify(payload));

		let treated = errorHandling.handleResponse(
			response,
			"controlService.bindUsersGroups"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "controlService.bindUsersGroups");
		return null;
	}
};


async function unbindUsersGroups(payload) {
	
	try {
	  const url = `${basePath}/user-vehicle-groups`;
  
	  const response = await api.delete(url, { data: payload });
  
	  // se 2xx, considera sucesso e retorna true
	  if (response.status >= 200 && response.status < 300) {
		return true;
	  }
  
	  // se quiser ainda passar no handleResponse:
	  const treated = errorHandling.handleResponse(
		response,
		"controlService.unbindUsersGroups"
	  );
	  return treated ?? false;
  
	} catch (error) {
	  errorHandling.cathError(error, "controlService.unbindUsersGroups");
	  return false;
	}
  }  

export const vehicleGroupService = {
	create,
	update,
	remove,
	fetchGroups,
	getGroupById,
	defineDefault,
	sendMovement,
	sendSpeed,
	insertEmail,
	listEmail,
	deleteEmail,
	sendGroups,
	bindUsersGroups,
	unbindUsersGroups
};
